import { render, staticRenderFns } from "./ForgotPasswordComponent.vue?vue&type=template&id=29379521&scoped=true&"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordComponent.vue?vue&type=style&index=0&id=29379521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29379521",
  null
  
)

export default component.exports